(function () {
  const MOBILE_BREAKPOINT = 750;
  const swiperInstances = new Map();

  const getGap = (section) => {
    const raw = getComputedStyle(section).getPropertyValue('--press-logos-gap').trim();
    return parseInt(raw, 10) || 40;
  };

  const createSwiper = (section) => {
    if (swiperInstances.has(section)) return;

    const sliderEl = section.querySelector('[data-press-logos-slider]');
    if (!sliderEl) return;

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 3,
      spaceBetween: getGap(section),
      grabCursor: true,
      watchOverflow: true,
    });

    swiperInstances.set(section, swiper);
  };

  const destroySwiper = (section) => {
    const swiper = swiperInstances.get(section);
    if (!swiper) return;
    swiper.destroy(true, true);
    swiperInstances.delete(section);
  };

  const initSlider = (section) => {
    const mq = window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`);

    const handleChange = (e) => {
      if (e.matches) {
        destroySwiper(section);
      } else {
        createSwiper(section);
      }
    };

    mq.addEventListener('change', handleChange);
    handleChange(mq);
  };

  const initAll = () => {
    document.querySelectorAll('.press-logos-section').forEach(initSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('press-logos-section')) {
      initSlider(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('press-logos-section')) {
      destroySwiper(event.target);
    }
  });
})();
